import React from 'react';
import PropTypes from 'prop-types';

import Section from '../section';

import {
  FieldName,
  FieldValue,
  Grid,
} from '../../styles';

const EndScreenSection = (props) => {
  const {
    baseUrl,
    values,
    smallColumn,
  } = props;

  const {
    thankYouTitle,
    thankYouContent,
  } = values;

  const width = smallColumn ? 4 : 6;

  return (
    <Section
      title="End screen"
      hasEdit={!!baseUrl}
      href={`${baseUrl}/survey#end-screen`}
    >
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column computer={width} tablet={4} mobile={8}>
            <FieldName>End screen title</FieldName>
          </Grid.Column>
          <Grid.Column width={10}>
            <FieldValue>{thankYouTitle}</FieldValue>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={2}>
          <Grid.Column computer={width} tablet={4} mobile={8}>
            <FieldName>End screen body</FieldName>
          </Grid.Column>
          <Grid.Column width={10}>
            <FieldValue>{thankYouContent}</FieldValue>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Section>
  );
};

EndScreenSection.propTypes = {
  values: PropTypes.shape({
    thankYouTitle: PropTypes.string,
    thankYouContent: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  baseUrl: PropTypes.string,
  smallColumn: PropTypes.bool,
};

EndScreenSection.defaultProps = {
  baseUrl: undefined,
  history: {},
  smallColumn: false,
};

export default EndScreenSection;
